import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { connect, useSelector } from "react-redux";
import {
  deleteTrialUser,
  getTrialUser,
  updateTrialUser,
} from "../store/actions";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  makeStyles,
  IconButton,
  Tooltip,
  Popover,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import logo from "../assets/images/logo-main-white.png";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import EditIcon from "@material-ui/icons/Edit";
import accessToken from "../helpers/jwt-token-access/accessToken";
import jwtDecode from "jwt-decode";
// import { Alert, AlertTitle } from "@mui/material";
import { Alert } from "reactstrap";
import spinner from "../assets/images/loadingGif.gif";

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: '800px', // Adjust the width as needed
    height: '500px', // Adjust the height as needed
  },
  dialogContent: {
    width: '800px', // Adjust the width as needed
    height: '500px', // Adjust the height as needed
  },
  textField: {
    width: '100%',
    height: '100%',
  },
  appBar: {
    backgroundColor: "#193a6f",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  heading: {
    fontFamily: "Roboto, Arial, sans-serif", // Custom font
    fontSize: "2rem",
    fontWeight: "bold",
    textAlign: 'center',
    color: '#193a6f'
  },
}));

const DemoRequestDetails = (props) => {
  const classes = useStyles();

  const token = accessToken();
  const decoded = jwtDecode(token);
  const userName = decoded["email"];
  const userRole = decoded["cognito:groups"];
  const [editDialogOpen, setEditDialogOpen] = useState(false); // State for tracking dialog open/close
  const [editedRowData, setEditedRowData] = useState(null); // State for tracking currently edited row data
  const [hover, setHover] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const isFirstRender = useRef(true);
  const loading = useSelector((state) => state.trialuser.loading);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAnchor = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  console.log("errors = ", props.error);

  const handleEdit = (rowData) => {
    if (userRole.includes("Admin") || userRole.includes("PowerUser")) {
      // check if userRole includes "Admin"
      setEditedRowData(rowData); // Set the edited row data
      setEditDialogOpen(true); // Open the edit dialog
    } else {
      alert("You are not eligible for editing comments."); // show alert if userRole does not include "Admin"
    }
  };

  const handleClose = () => {
    setEditedRowData(null); // Reset edited row data
    setEditDialogOpen(false); // Close the edit dialog
  };

  const columns = [
    // { field: "id", headerName: "First Name" },
    { field: "firstName", headerName: "First Name" },
    { field: "lastName", headerName: "Last Name" },
    { field: "company", headerName: "Company", width: 250 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "phoneNumber", headerName: "Phone Number", width: 150 },
    { field: "address", headerName: "Address", width: 250 },
    { field: "city", headerName: "City" },
    { field: "province", headerName: "Province" },
    { field: "zip", headerName: "Zip" },
    { field: "createdDate", headerName: "Created Date [UTC]", width: 250 },
    { field: "lastModifiedBy", headerName: "Last Modified By", width: 250 },
    { field: "lastModifiedDate", headerName: "Last Modified Date", width: 250 },
    { field: "comments", headerName: "Comments", width: 300, editable: true },
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      renderCell: (params) => {
        // Check if the user is an admin
        if (userRole.includes("Admin") || userRole.includes("PowerUser")) {
          return (
            <IconButton color="primary" onClick={() => handleEdit(params.row)}>
              <EditIcon />
            </IconButton>
          );
        } else {
          return (
            <IconButton color="primary" disabled className="Mui-disabled">
              <EditIcon />
            </IconButton>
          );
        }
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 100,
      renderCell: (params) => {
        // Check if the user is an admin
        if (userRole.includes("Admin")) {
          return (
            <IconButton
              color="secondary"
              onClick={() => {
                props.deleteTrialUser(params.row);
                //Added the following
                //props.getTrialUser();
              }}
            >
              <DeleteIcon />
            </IconButton>
          );
        } else {
          return (
            <IconButton color="secondary" disabled className="Mui-disabled">
              <DeleteIcon />
            </IconButton>
          );
        }
      },
    },
  ];

  useEffect(() => {
    props.getTrialUser();
    // console.log(props.getTrialUser())
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      console.log("First Rendered");
      isFirstRender.current = false;
    } else {
      if (props.users) {
        if (props.users.length > 0) {
          setShowSuccessMessage(true);
          setTimeout(() => {
            setShowSuccessMessage(false);
          }, 15000); // Hide the success message after 15 seconds
        }
      }
    }
    return () => {
      isFirstRender.current = true;
    };
  }, [props.users]);

  console.log("Props", props);

  return (
    <div>
      <div>
        <Typography variant="h1" className={classes.heading}>
          Demo Register Form Details
        </Typography>
        {props.users && (
          <>
            {" "}
            {/* <Button
              variant="contained"
              color="primary"
              disabled={!editedRowData}
            >
              Edit
            </Button> */}
            {showSuccessMessage && (
              // <Alert severity="success">
              //   <AlertTitle>Success</AlertTitle>
              //   User list updated successfully!
              // </Alert>
              <Alert className="mt-3 mb-0" color="success">
                User list updated successfully!
              </Alert>
            )}
            {props.error && (
              <Alert className="mt-3 mb-0" color="error">
                {JSON.stringify(props.error)}
                {JSON.stringify(props.message)}
              </Alert>
            )}
            {loading ? (
              <div
                style={{
                  display: "flex",
                  direction: "row",
                  alignContent: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  justifyItems: "center",
                  height: "100vh",
                }}
              >
                <img src={spinner} width="80px" alt="Spinner" />
              </div>
            ) : (
              <DataGrid
                columns={columns}
                rows={props.users}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    csvOptions: { disableToolbarButton: true },
                    printOptions: { disableToolbarButton: true },
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                getRowId={(row) => row.key}
                autoHeight
                pagination
              />
            )}
          </>
        )}
        {!props.users && (
          <div
            style={{
              display: "flex",
              direction: "row",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
              height: "100vh",
            }}
          >
            <img src={spinner} width="80px" alt="Spinner" />
          </div>
        )}
      </div>
      <Dialog classes={{ paper: classes.dialog }} open={editDialogOpen} onClose={handleClose}>
        <DialogTitle>Edit Comments</DialogTitle>
        <DialogContent style={{maxHeight: "100%"}}>
          <TextField
          style={{height: "100%"}}
            label="Comments"
            fullWidth
            multiline
            rows={15}
            value={editedRowData && editedRowData.comments}
            onChange={(e) =>
              setEditedRowData({
                ...editedRowData,
                comments: e.target.value,
              })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              // Call updateTrialUser with the updated row data
              console.log("editedRowData=", editedRowData);
              props.updateTrialUser(editedRowData);
              handleClose();
              //Added the following
              //props.getTrialUser();
            }}
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTrialUser: () => {
      dispatch(getTrialUser());
    },
    updateTrialUser: (row) => {
      dispatch(updateTrialUser(row));
    },
    deleteTrialUser: (row) => {
      console.log("deleteTrialUser row=", row);
      dispatch(deleteTrialUser(row));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    users: state.trialuser.users, // Replace with the correct path to user data in Redux store
    error: state.trialuser.userError,
    message: state.trialuser.message,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DemoRequestDetails);
